import { Controller } from "@hotwired/stimulus"

// Simplified modal controller that follows Rails conventions
// The modal is closed ONLY when the server explicitly removes it via Turbo Stream
export default class extends Controller {
  static targets = ["modal"]

  connect() {
    // Wait for the modal to be fully visible before closing dropdowns
    setTimeout(() => {
      this.closeAllDropdowns()
    }, 50)
  }

  // Manual close via user action (X button or ESC key)
  hideModal() {
    // Remove the turbo frame's src to prevent reloading
    this.element.parentElement.removeAttribute("src")
    // Remove the modal element
    this.modalTarget.remove()
  }

  // REMOVED submitEnd method - let the server control modal closing
  // The Rails way: server responses determine UI behavior

  // Close with ESC key
  closeWithKeyboard(e) {
    if (e.code == "Escape") {
      this.hideModal()
    }
  }

  // Close when clicking background
  closeBackground(e) {
    if (e && this.modalTarget.contains(e.target)) {
      return
    }
    this.hideModal()
  }

  closeAllDropdowns() {
    // Dispatch a custom event that dropdown controllers can listen to
    document.dispatchEvent(new CustomEvent('modal:opening', {
      bubbles: true,
      detail: { modalController: this }
    }))
  }
}